package ru.villawonka.app.data.entity.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import ru.villawonka.app.domain.model.*

@Serializable
data class UserCountryResponse(
    @SerialName("country")
    val country: String,
    @SerialName("cities")
    val cities: List<CityData>,
    @SerialName("accommodation_types")
    val accommodationTypes: List<String>,
    @SerialName("accommodation_additions")
    val accommodationAdditions: List<String>,
)

@Serializable
data class CityData(
    @SerialName("city")
    val city: String,
    @SerialName("districts")
    val districts: List<String>,
)

fun UserCountryResponse.toDomain() = UserCountryDomain(
    country = CountryFactory.from(country),
    cities = cities.map { it.toDomain() },
    accommodationAdditions = accommodationAdditions.mapNotNull(AccommodationAdditionFactory::from),
    accommodationTypes = accommodationTypes.mapNotNull(AccommodationTypeFactory::from)
)

fun CityData.toDomain() = CityInfoDomain(
    city = city,
    districts = districts
)

object CountryFactory {
     fun from(value: String): CountryDomain = when(value) {
        "ID" -> CountryDomain.INDONESIA
        "TH" -> CountryDomain.THAILAND
        "VN" -> CountryDomain.VIETNAM
        else -> throw IllegalArgumentException("$value can't be parsed!")
    }
}

object AccommodationTypeFactory {
    fun from(value: String): AccommodationTypeDomain? = when(value) {
        "villa" -> AccommodationTypeDomain.VILLA
        "apartment" -> AccommodationTypeDomain.APARTMENT
        "guesthouse" -> AccommodationTypeDomain.GUESTHOUSE
        "room" -> AccommodationTypeDomain.ROOM
        else -> null
    }
}

object AccommodationAdditionFactory {
    fun from(value: String): AccommodationAdditionDomain? = when(value) {
        "near_gym" -> AccommodationAdditionDomain.NEAR_GYM
        "near_beach" -> AccommodationAdditionDomain.NEAR_BEACH
        "tv" -> AccommodationAdditionDomain.TV
        "wifi" -> AccommodationAdditionDomain.WIFI
        "washing_machine" -> AccommodationAdditionDomain.WASHING_MACHINE
        "safe" -> AccommodationAdditionDomain.SAFE
        "jacuzzi" -> AccommodationAdditionDomain.JACUZZI
        "air_condition" -> AccommodationAdditionDomain.AIR_CONDITION
        "terrace" -> AccommodationAdditionDomain.TERRACE
        "video_surveillance" -> AccommodationAdditionDomain.VIDEO_SURVEILLANCE
        "barbecue_area" -> AccommodationAdditionDomain.BARBECUE_AREA
        "pool" -> AccommodationAdditionDomain.POOL
        "parking" -> AccommodationAdditionDomain.PARKING
        "cleaning" -> AccommodationAdditionDomain.CLEANING
        "closed_kitchen" -> AccommodationAdditionDomain.CLOSED_KITCHEN
        "closed_living_room" -> AccommodationAdditionDomain.CLOSED_LIVING_ROOM
        "utility_bills_included" -> AccommodationAdditionDomain.UTILITY_BILLS_INCLUDED
        "drink_water_included" -> AccommodationAdditionDomain.DRINK_WATER_INCLUDED
        "has_discount" -> AccommodationAdditionDomain.HAS_DISCOUNT
        else -> null
    }
}